var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"wrapper",staticClass:"wrapper",class:{ 'nav-open': _vm.$sidebar.showSidebar }},[_c('notifications'),_c('sidebar-fixed-toggle-button'),(!_vm.loggedUser.active)?_c('side-bar',{attrs:{"background-color":_vm.sidebarBackground},scopedSlots:_vm._u([{key:"links",fn:function(props){return [_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.dashboard'),
          icon: 'tim-icons icon-chart-pie-36',
          path: '/dashboard'
        }}})]}}],null,false,1174815926)}):_vm._e(),(_vm.loggedUser.active)?_c('side-bar',{attrs:{"background-color":_vm.sidebarBackground},scopedSlots:_vm._u([{key:"links",fn:function(props){return [_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.dashboard'),
          icon: 'tim-icons icon-chart-pie-36',
          path: '/dashboard'
        }}}),(_vm.loggedUser.role == _vm.UserRoles.APPLICANT)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.ongoing_applications'),
          icon: 'tim-icons icon-notes',
          path: '/ongoing-applications'
        }}}):_vm._e(),(_vm.loggedUser.role !== _vm.UserRoles.APPLICANT)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.applications'),
          icon: 'tim-icons icon-notes',
          path: '/applications'
        }}}):_vm._e(),(_vm.loggedUser.role == _vm.UserRoles.APPLICANT)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.current_grants'),
          icon: 'tim-icons icon-app',
          path: '/grants'
        }}}):_vm._e(),(_vm.loggedUser.role == _vm.UserRoles.ADMIN)?_c('sidebar-item',{attrs:{"link":{
          name: 'Translations',
          icon: 'tim-icons icon-chat-33'
        }}},[_c('sidebar-item',{attrs:{"link":{
          name: 'Translations',
          path: '/translations/translations'
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Languages',
          path: '/translations/languages'
        }}})],1):_vm._e(),(_vm.loggedUser.role == _vm.UserRoles.ADMIN)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.messaging'),
          icon: 'tim-icons icon-email-85',
          path: '/messaging'
        }}}):_vm._e(),(_vm.loggedUser.role == _vm.UserRoles.ADMIN || _vm.loggedUser.role == _vm.UserRoles.REGIONAL_ADMIN || _vm.loggedUser.role == _vm.UserRoles.AUDITOR)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.monitoring'),
          icon: 'tim-icons icon-check-2',
          path: '/monitoring'
        }}}):_vm._e(),(_vm.loggedUser.role == _vm.UserRoles.APPLICANT)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.applicant_monitoring'),
          icon: 'tim-icons icon-check-2',
          path: '/monitoring'
        }}}):_vm._e(),(_vm.loggedUser.role == _vm.UserRoles.ADMIN || _vm.loggedUser.role == _vm.UserRoles.REGIONAL_ADMIN || _vm.loggedUser.role == _vm.UserRoles.AUDITOR)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.logmonitoring'),
          icon: 'tim-icons icon-notes',
          path: '/logmonitoring'
        }}}):_vm._e(),(_vm.loggedUser.role !== _vm.UserRoles.AUDITOR)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.requests'),
          icon: 'tim-icons icon-alert-circle-exc',
          path: '/clarifications'
        }}}):_vm._e(),(_vm.loggedUser.role !== _vm.UserRoles.APPLICANT && _vm.loggedUser.role !== _vm.UserRoles.AUDITOR)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.reports'),
          icon: 'tim-icons icon-single-copy-04',
          path: '/reports'
        }}}):_vm._e(),(_vm.loggedUser.role == _vm.UserRoles.ADMIN)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.user_management'),
          icon: 'tim-icons icon-single-02',
          path: '/users-management'
        }}}):_vm._e()]}}],null,false,2260248059)}):_vm._e(),_c('div',{staticClass:"main-panel",attrs:{"data":_vm.sidebarBackground}},[_c('dashboard-navbar'),_c('router-view',{attrs:{"name":"header"}}),_c('div',{class:{ content: !_vm.$route.meta.hideContent },on:{"click":_vm.toggleSidebar}},[_c('zoom-center-transition',{attrs:{"duration":200,"mode":"out-in"}},[_c('router-view')],1)],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }